import { withInstall } from '@/utils'
import TabsClueCosFollowUp from './src/index.vue'
export default withInstall(TabsClueCosFollowUp)
